// ============================================================================
// LES MOYENS DE RÈGLEMENT — un libellé, un dessin, une teinte, pour tout le back-office.
//
// ⚠️ EXTRAIT DU JOURNAL À SON DEUXIÈME USAGE (règle de 2, §24.3) : l'écran « Z & clôtures » ventile
// les règlements du jour et a besoin des MÊMES libellés. Recopiée, la table aurait fini par nommer
// « Chèque » ici et « CHQ » là, pour la même colonne de la même base.
// ============================================================================

/**
 * ⚠️ LE DESSIN EST L'INFORMATION là où ces moyens s'affichent : à 12,5 px on reconnaît l'icône avant
 * de lire le mot. Un moyen qui emprunterait l'icône d'un autre se lirait donc de travers.
 * ⚠️ LES QUATRE PREMIERS VIENNENT DE LA MAQUETTE (§25) avec leurs teintes ; les suivants n'y figurent
 * pas — ils prennent un dessin juste et une teinte NEUTRE plutôt qu'une couleur inventée, qui
 * laisserait croire à une famille qui n'existe pas.
 * ⚠️ LES LIBELLÉS SONT DES CLÉS, PAS DES TEXTES. Cette table est évaluée AU CHARGEMENT du module :
 * y écrire `t()` figerait le français avant que la langue du compte n'arrive. `key()` déclare la
 * chaîne sans rien traduire, et la résolution a lieu dans `libelleReglement`, au rendu.
 */
import type { IconName } from '@orgazone/ui-tokens';
import { key, t, type Translatable } from './i18n';
export const REGLEMENTS: Record<string, { label: Translatable; icon: IconName; tone: string }> = {
  CB: { label: key('Carte bancaire'), icon: 'card', tone: 'var(--blue-fg)' },
  ESP: { label: key('Espèces'), icon: 'cash', tone: 'var(--teal-700)' },
  CHQ: { label: key('Chèque'), icon: 'cheque', tone: 'var(--violet-fg)' },
  CADEAU: { label: key('Chèque cadeau'), icon: 'gift', tone: 'var(--violet-fg)' },
  AVOIR: { label: key('Avoir'), icon: 'returnBox', tone: 'var(--rose-fg)' },
  VIR: { label: key('Virement'), icon: 'wallet', tone: 'var(--ink-500)' },
  ACOMPTE: { label: key('Acompte'), icon: 'wallet', tone: 'var(--ink-500)' },
  TRESTO: { label: key('Titre restaurant'), icon: 'receipt', tone: 'var(--ink-500)' },
  AUTRE: { label: key('Autre'), icon: 'wallet', tone: 'var(--ink-500)' },
};

/**
 * Le libellé d'un code, RÉSOLU dans la langue du compte.
 * ⚠️ UN CODE INCONNU EST RENDU TEL QUEL : le remplacer par « Autre » effacerait l'information qui
 * permet justement de comprendre d'où il sort. Il ne passe donc PAS par le résolveur — ce n'est pas
 * une de nos clés, et le traduire n'aurait aucun sens.
 * ⚠️ C'EST ICI QUE LA TRADUCTION A LIEU, et nulle part ailleurs : `REGLEMENTS[c].label` lu directement
 * affiche le français. La garde `audit-cles-non-resolues` existe pour cette raison exacte.
 */
export function libelleReglement(code: string): string {
  const connu = REGLEMENTS[code];
  return connu ? t(connu.label) : code;
}
